/** credit_products.id — AVATAR IKONI-teemapaketti: horoskoopit */
export const HOROSCOPE_TEEMAPAKETTI_PRODUCT_ID = 'tier1-avatar-horoskoopit';

/** Lucide zodiac badge values + Finnish labels (optgroup «Horoskoopit»). */
export const ZODIAC_BADGE_OPTIONS = [
  { value: 'zodiac-aries', label: 'Oinas' },
  { value: 'zodiac-taurus', label: 'Härkä' },
  { value: 'zodiac-gemini', label: 'Kaksonen' },
  { value: 'zodiac-cancer', label: 'Rapu' },
  { value: 'zodiac-leo', label: 'Leijona' },
  { value: 'zodiac-virgo', label: 'Neitsyt' },
  { value: 'zodiac-libra', label: 'Vaaka' },
  { value: 'zodiac-scorpio', label: 'Skorpioni' },
  { value: 'zodiac-sagittarius', label: 'Jousimies' },
  { value: 'zodiac-capricorn', label: 'Kauris' },
  { value: 'zodiac-aquarius', label: 'Vesimies' },
  { value: 'zodiac-pisces', label: 'Kalat' },
  { value: 'zodiac-ophiuchus', label: 'Käärmeenkantaja' },
];

export const ZODIAC_BADGE_TYPE_VALUES = ZODIAC_BADGE_OPTIONS.map((o) => o.value);
